<template>
    <div>
        <v-list subheader dense>
            <v-subheader>Click on project to display details</v-subheader>
            <template v-for="event in data">

                <v-list-item @click="showDetails(event)">
                    <v-list-item-avatar>
                        <avatar
                            :image-url="event.project.created_by.photo_url"
                            :person-name="event.project.created_by.name"
                        ></avatar>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        {{ event.project.name }}
                    </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
            </template>
        </v-list>

        <v-dialog v-model="dialogOpen" v-if="eventData" width="450px">
            <v-card flat>

                <v-toolbar color="primary" dark dense>
                    <v-icon>mdi-calendar</v-icon>
                    <v-toolbar-title v-html="eventData.title"></v-toolbar-title>
                </v-toolbar>

                <v-card-text primary-title>
                    <project-details-card @edit="editProject"
                                          :project="eventData.project"
                    ></project-details-card>
                </v-card-text>

            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import Avatar from '../../../components/UI/Avatar';
    import ProjectDetailsCard from './ProjectDetailsCard';

    export default {

        components: {
            Avatar,
            ProjectDetailsCard
        },

        props: {
            data: {
                type: Array,
                required: true,
            }
        },

        data() {
            return {
                dialogOpen: false,
                eventData: null
            }
        },

        methods: {
            editProject(project) {
                this.$emit('edit', project);
            },
            showDetails(event) {
                this.eventData = event;
                this.dialogOpen = true;
            }
        }
    }
</script>
